import React from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";

const BestCountriesToStudyAbroad = () => {
    return (
        <>
            <style>
                {`
            .countriesimg{
                background: #fff;
    box-shadow: 0px 2px 18px #eee;
    padding: 20px;
    border-radius: 25px;
    }
            `}
            </style>
            <BannerBreadcrumb head={"Popular Countries to Study Abroad"} parades={"Make informed decisions. Discover everything you need to know about top study-abroad destinations."} pagename={"Countries"} />
            <div className="container mt-5 mb-5">
                <div className="row">
                    <h5 className="about-head text-center mb-4" style={{ color: "var(--primarycolor" }} >Best Countries to Study Abroad</h5>
                    <div className="col text-center">
                        <img src="images/usa-flag.svg" alt="USA Flag" className="img-fluid countriesimg" />
                        <h6 className="mt-2">USA</h6>
                    </div>
                    <div className="col text-center">
                        <img src="images/uk-fllag.svg" alt="USA Flag" className="img-fluid countriesimg" />
                        <h6 className="mt-2">UK</h6>
                    </div>
                    <div className="col text-center">
                        <img src="images/canada-flag.svg" alt="USA Flag" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Canada</h6>
                    </div>
                    <div className="col text-center">
                        <img src="images/ireland-flag.png" alt="USA Flag" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Ireland</h6>
                    </div>
                    <div className="col text-center">
                        <img src="images/australia-flag.svg" alt="USA Flag" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Australia</h6>
                    </div>
                    <div className="col text-center">
                        <img src="images/newzealand-flag.svg" alt="USA Flag" className="img-fluid countriesimg" />
                        <h6 className="mt-2">New Zealand</h6>
                    </div>
                    <div className="col text-center">
                        <img src="images/germany-flag.svg" alt="USA Flag" className="img-fluid countriesimg" />
                        <h6 className="mt-2">Germany</h6>
                    </div>
                    <div className="col text-center">
                        <img src="images/france-flag.png" alt="USA Flag" className="img-fluid countriesimg" />
                        <h6 className="mt-2">France</h6>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BestCountriesToStudyAbroad;